/**
 * Utility functions for building CalendarEmbed metadata.
 * These ensure consistent metadata structure and prevent missing required fields.
 */

interface ProgramSessionMetadata extends Record<string, string> {
  appointment_type: 'PROGRAM_SESSION'
  user_id: string
  session_id: string
  program_enrollment_id: string
}

interface OnboardingMetadata extends Record<string, string> {
  appointment_type: 'CONSULTATION_ONBOARDING'
  user_id: string
  consultation_id: string
}

/**
 * Build metadata for program session bookings.
 * Used when booking a consultation session.
 */
export const buildProgramSessionMetadata = (
  userId: string | number,
  sessionId: string | number,
  programEnrollmentId?: string | number
): ProgramSessionMetadata => {
  const metadata: ProgramSessionMetadata = {
    appointment_type: 'PROGRAM_SESSION',
    user_id: String(userId),
    session_id: String(sessionId),
    program_enrollment_id: '',
  }

  if (programEnrollmentId !== undefined) {
    metadata.program_enrollment_id = String(programEnrollmentId)
  }

  return metadata
}

/**
 * Build metadata for consultation onboarding call bookings.
 */
export const buildOnboardingMetadata = (
  userId?: string | number,
  consultationId?: string | number
): OnboardingMetadata => ({
  appointment_type: 'CONSULTATION_ONBOARDING',
  user_id: String(userId),
  consultation_id: String(consultationId),
})
